import React, { Component } from "react";
import { Modal, Form, Input, DatePicker, Select } from "antd";
import moment from "moment";
import http from "../../../axios/http";
import messager from "../../ui/messager";
const { Option } = Select;
const FormItem = Form.Item;

class StockCheckVehicleEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feeRules: [],
      members: [],
      memberList: [],
    };
  }

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      if (editData.collectionDate)
        values["collectionDate"] = editData.collectionDate;
      else delete values["collectionDate"];
      if (editData.transferDate) values["transferDate"] = editData.transferDate;
      else delete values["transferDate"];
      if (editData.leaveDate) values["leaveDate"] = editData.leaveDate;
      else delete values["leaveDate"];
      if (editData.memberCode) values["memberCode"] = editData.memberCode;
      else delete values["memberCode"];
      http.post({
        url: "/vehicleStockCheck/saveVehicle",
        data: values,
        success: (res) => {
          messager.notify("保存成功");
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };
  componentWillMount() {
    this.loadMembers();
  }
  loadMembers() {
    http.post({
      url: "/vehicleStockCheck/findMember",
      data: { name: "", pageNumber: 1, pageSize: 500 },
      success: (res) => {
        let memberList = [];
        if (res.content) {
          res.content.forEach((item) => {
            memberList.push({ value: item.code, label: item.name });
          });
        }
        this.setState({ members: memberList, memberList });
      },
    });
  }

  onMemberSearch = (val) => {
    console.log("membersearch", val);
  };

  getMemberListOption(memberList) {
    let doms = [];
    memberList.forEach((item) => {
      doms.push(
        <Option value={item.value} key={item.value}>
          {item.label}
        </Option>
      );
    });
    return doms;
  }

  onMemberChange = (val) => {
    this.props.editData.memberCode = val;
  };

  onCollectionDateChange = (item, val) => {
    this.props.editData.collectionDate = val;
  };

  onTransferDateChange = (item, val) => {
    this.props.editData.transferDate = val;
  };

  onLeaveDateChange = (item, val) => {
    this.props.editData.leaveDate = val;
  };

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { memberList } = this.state;
    const { getFieldDecorator } = form;
    return (
      <Modal
        visible={visible}
        title="盘点车辆编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车架号：">
            {getFieldDecorator("vin", {
              rules: [
                {
                  required: editData.specialCustomer && true,
                  message: "请输入车架号!",
                },
                { max: 20, message: "最多只能输入20个字符！" },
              ],
              initialValue: editData.vin,
            })(<Input disabled={!editData.specialCustomer} />)}
          </FormItem>
          <FormItem label="车辆名称">
            {getFieldDecorator("name", {
              rules: [
                {
                  required: editData.specialCustomer && true,
                  message: "请输入车辆名称!",
                },
                { max: 50, message: "最多只能输入50个字符！" },
              ],
              initialValue: editData.name,
            })(<Input disabled={!editData.specialCustomer} />)}
          </FormItem>
          <FormItem label="车牌号：">
            {getFieldDecorator("plateNo", {
              rules: [{ max: 10, message: "最多只能输入10个字符！" }],
              initialValue: editData.plateNo,
            })(<Input disabled={!editData.specialCustomer} />)}
          </FormItem>
          <FormItem label="品牌车型：">
            {getFieldDecorator("brand", {
              rules: [
                {
                  required: editData.specialCustomer && true,
                  message: "请输入品牌车型!",
                },
                { max: 20, message: "最多只能输入20个字符！" },
              ],
              initialValue: editData.brand,
            })(<Input disabled={!editData.specialCustomer} />)}
          </FormItem>
          <FormItem label="商户：">
            {getFieldDecorator("memberName", {
              rules: [
                {
                  message: "请选择商户!",
                },
              ],
              initialValue: editData.memberName,
            })(
              <Select
                disabled={!editData.specialCustomer}
                showSearch
                placeholder="请选择商户"
                onChange={this.onMemberChange}
                onSearch={this.onMemberSearch}
                filterOption={(input, option) => {
                  return option.props.children.indexOf(input) >= 0;
                }}
              >
                {this.getMemberListOption(memberList)}
              </Select>
            )}
          </FormItem>
          <FormItem label="车主名：">
            {getFieldDecorator("owner", {
              rules: [{ max: 20, message: "最多只能输入20个字符！" }],
              initialValue: editData.owner,
            })(<Input disabled={!editData.specialCustomer} />)}
          </FormItem>
          <FormItem label="过户日期：">
            {getFieldDecorator("transferDate", {
              initialValue: moment(editData.transferDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onTransferDateChange}
                placeholder="过户日期"
              />
            )}
          </FormItem>
          <FormItem label="收款日期：">
            {getFieldDecorator("collectionDate", {
              initialValue: moment(editData.collectionDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onCollectionDateChange}
                placeholder="收款日期"
              />
            )}
          </FormItem>
          <FormItem label="出库日期：">
            {getFieldDecorator("leaveDate", {
              initialValue: moment(editData.leaveDate, "YYYY-MM-DD"),
            })(
              <DatePicker
                onChange={this.onLeaveDateChange}
                placeholder="出库日期"
              />
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const StockCheckVehicleEdit = Form.create()(StockCheckVehicleEditForm);

export default StockCheckVehicleEdit;
